module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0093.jpg?v=81422526";